<template>
  <div>
    <b-card>
      <h1>ساخت پلن جدید</h1>
      <b-tabs v-model="activeTab">
        <b-tab active>
          <template #title>
            <feather-icon icon="PackageIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">پلن ثبت آگهی</span>
          </template>
          <b-form class="mt-2">
            <b-row>
              <b-col md="6">
                <b-form-group label="عنوان پلن" label-for="title" class="mb-2">
                  <b-form-input id="plan-price" v-model="planDetails.title" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="قیمت (تومان)"
                  label-for="plan-price"
                  class="mb-2"
                >
                  <b-form-input id="plan-price" v-model="planDetails.price" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="countTitleHandler"
                  label-for="plan-count"
                  class="mb-2"
                >
                  <b-form-input id="plan-count" v-model="planDetails.count" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="مدت فعال بودن پلن (روز)"
                  label-for="plan-expire"
                  class="mb-2"
                >
                  <b-form-input
                    id="plan-expire"
                    v-model="planDetails.expireDays"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mt-50">
                <b-button variant="primary" class="mr-1" @click="createNewPlan">
                  ساخت پلن
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="PackageIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">پلن بازدید آگهی</span>
          </template>
          <b-form class="mt-2">
            <b-row>
              <b-col md="6">
                <b-form-group label="عنوان پلن" label-for="title" class="mb-2">
                  <b-form-input id="plan-price" v-model="planDetails.title" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="قیمت (تومان)"
                  label-for="plan-price"
                  class="mb-2"
                >
                  <b-form-input id="plan-price" v-model="planDetails.price" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="countTitleHandler"
                  label-for="plan-count"
                  class="mb-2"
                >
                  <b-form-input id="plan-count" v-model="planDetails.count" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="مدت فعال بودن پلن (روز)"
                  label-for="plan-expire"
                  class="mb-2"
                >
                  <b-form-input
                    id="plan-expire"
                    v-model="planDetails.expireDays"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mt-50">
                <b-button variant="primary" class="mr-1" @click="createNewPlan">
                  ساخت پلن
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import PlanCreateRequest from "@/libs/Api/Plans/PlanCreateRequest";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BTabs,
    BTab,
    BFormGroup,
    BFormTextarea,
    BBadge,
    BForm,
    BDropdown,
    BDropdownItem,
    BPagination,
    ToastificationContent,
    BModal,
    vSelect,
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(val) {
        // Set plan type and user type based on active tab
        this.planDetails = {
          title: null,
          userType: null,
          price: null,
          count: null,
          expireDays: 30,
          planType: null,
        };
        this.planDetails.userType = val + 1;
        this.planDetails.planType = val + 2;
      },
    },
  },
  data() {
    return {
      planDetails: {
        title: null,
        userType: null,
        price: null,
        count: null,
        expireDays: 30,
        planType: null,
      },
      userType: [
        {
          name: "ثبت کننده",
          value: 1,
        },
        {
          name: "بازدید کننده",
          value: 2,
        },
      ],
      planType: [
        {
          name: "نردبان",
          value: 1,
        },
        {
          name: "پکیج ثبت آگهی",
          value: 2,
        },
        {
          name: "پکیج بازدید آگهی",
          value: 3,
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    async createNewPlan() {
      let _this = this;
      let planCreateRequest = new PlanCreateRequest(_this);
      planCreateRequest.setParams(_this.planDetails);
      await planCreateRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `پلن با موفقیت ساخته شد.`,
            },
          });
          _this.$router.push({ name: "apps-plans-list" });
        },
        function (error) {
          console.log(error);
        }
      );
    },
  },
  computed: {
    countTitleHandler() {
      if (this.planDetails.userType) {
        if (this.planDetails.userType == 1) {
          return "تعداد آگهی قابل ثبت";
        } else if (this.planDetails.userType == 2) {
          return "تعداد آگهی قابل مشاهده";
        }
      } else {
        return "تعداد";
      }
    },
  },
};
</script>
